/*
 * 机器人拨打记录
 * */
import { dialerClient } from "@/api/index";
import { RobotCallRecordListReq } from "@/pbjs/xcommon/dialer_pb";
import InnerRequest from "./request";
import {setPage} from "@/utils/request";
import { Page, timeFormat } from "@/utils/index";
// lin 获取工单分配支持的所有的参数数据
interface Options {
    OrderId: string;
    Page: Page;
}
export function setRobotCallOutRecordListParamsReq(arg: Options) {
    let request: any = new RobotCallRecordListReq();
    request.setOrderid(arg.OrderId);
    request.setPagein(setPage(arg.Page.pageIndex, arg.Page.pageSize));
    return request;
}
export const getRobotCallOutRecordRequest = new InnerRequest(
    dialerClient,
    dialerClient.getRobotCallRecordList
);
